<script setup>
   //this section MUST NOT be used, anything that would need to be put here needs to be added to a global middleware. This component MUST only be used for layout
</script>

<template>
   <div>
      <NuxtLayout>
         <NuxtPage />
      </NuxtLayout>
   </div>
</template>
